import { LoopType } from './LoopType';

export class TweenUtil {
  /**
   * Tween loop funciton
   * @param looptype loop type
   * @param now now
   * @param min min
   * @param max max
   */
  public static loopFunc(looptype: LoopType, now: number, min: number, max: number): number {
    switch (looptype) {
      case LoopType.CLAMP:
        return this.clamp(now, min, max);
      case LoopType.REPEAT:
        return this.repeat(now, min, max);
      case LoopType.YOYO:
        return this.yoyo(now, min, max);
    }
  }

  private static clamp(now: number, min: number, max: number): number {
    if (now > max) return max;
    if (now < min) return min;
    return now;
  }

  private static repeat(now: number, min: number, max: number): number {
    if (now > max) return min + (now - max);
    if (now < min) return max - (min - now);
    return now;
  }

  private static yoyo(now: number, min: number, max: number): number {
    if (now > max) return max - (now - max);
    if (now < min) return min + (min - now);
    return now;
  }
}
